export default __webpack_public_path__ + "static/media/call.c02fd6a3.svg";